var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(-1679.643 -1067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(1703.643 1067) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    fill: "none",
    stroke: "#eaf5ed",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M5.937,12.076A6.2,6.2,0,0,1,.016,7.6a.445.445,0,0,1,.132-.439.421.421,0,0,1,.439-.132,4.942,4.942,0,0,0,1.4.219A5.278,5.278,0,0,0,7.252,1.99a4.942,4.942,0,0,0-.219-1.4A.445.445,0,0,1,7.165.148.421.421,0,0,1,7.6.016a6.146,6.146,0,0,1-1.666,12.06ZM1.113,8.086A5.275,5.275,0,0,0,11.2,5.937,5.331,5.331,0,0,0,8.085,1.113a5.877,5.877,0,0,1,.044.877A6.158,6.158,0,0,1,1.99,8.129,6.177,6.177,0,0,1,1.113,8.086Z",
    transform: "translate(1684.643 1072.962)",
    fill: "#eaf5ed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoche);
export default __webpack_public_path__ + "static/media/Noche.dd2823553fde4624fc4a7d9bde2cf95c.svg";
export { ForwardRef as ReactComponent };